/* Stable Robes theme JS: cart drawer (Shopify Ajax API), product page, menus. No dependencies. */
(function () {
  'use strict';
  var CG = window.CG || { routes: { cart: '/cart', add: '/cart/add', change: '/cart/change', product: '/collections/all' }, moneyFormat: '${{amount}}', freeShip: 8000 };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- money (mirrors Shopify's money_format) ---------- */
  function money(cents) {
    var format = CG.moneyFormat || '${{amount}}';
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format); var type = m ? m[1] : 'amount';
    function fmt(n, precision, thousands, decimal) {
      var s = (Number(n) / 100).toFixed(precision); var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    var v;
    switch (type) {
      case 'amount_no_decimals': v = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': v = fmt(cents, 0, ' ', '.'); break;
      case 'amount_with_space_separator': v = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': v = fmt(cents, 2, ' ', '.'); break;
      default: v = fmt(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) { var t = $('#toast'); if (!t) return; t.textContent = msg; t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 2200); }

  /* ---------- drawers ---------- */
  function lock() { var c = $('#cartDrawer'), m = $('#mobileNav'); document.body.classList.toggle('locked', (c && c.classList.contains('on')) || (m && m.classList.contains('on'))); }
  function openCart() { var d = $('#cartDrawer'); if (!d) return; d.classList.add('on'); d.setAttribute('aria-hidden', 'false'); $('#cartOverlay').classList.add('on'); lock(); }
  function closeCart() { var d = $('#cartDrawer'); if (!d) return; d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); $('#cartOverlay').classList.remove('on'); lock(); }
  function openMenu() { var n = $('#mobileNav'); if (!n) return; n.classList.add('on'); n.setAttribute('aria-hidden', 'false'); $('#menuOverlay').classList.add('on'); lock(); }
  function closeMenu() { var n = $('#mobileNav'); if (!n) return; n.classList.remove('on'); n.setAttribute('aria-hidden', 'true'); $('#menuOverlay').classList.remove('on'); lock(); }

  /* ---------- cart ---------- */
  function cartImg(item) {
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!src) return '';
    return src.replace(/(\.(?:jpe?g|png|gif|webp))(\?.*)?$/i, '_144x144_crop_center$1$2');
  }
  function renderCart(cart) {
    var count = $('#cartCount'); if (count) count.textContent = cart.item_count;
    var ship = $('#cartShip');
    if (ship) {
      var left = CG.freeShip - cart.total_price;
      var pct = Math.min(100, CG.freeShip ? (cart.total_price / CG.freeShip) * 100 : 100);
      ship.innerHTML = (left > 0 ? 'You are <b>' + money(left) + '</b> away from free shipping' : '<b>Free shipping unlocked.</b> Well done.') + '<div class="bar"><i style="width:' + pct + '%"></i></div>';
    }
    var lines = $('#cartLines');
    if (lines) {
      if (!cart.items.length) {
        lines.innerHTML = '<div class="empty"><p>Your cart is empty.</p><a class="btn ghost" href="' + esc(CG.routes.product) + '" data-close-cart>GET THE ROBE</a></div>';
      } else {
        lines.innerHTML = cart.items.map(function (it, i) {
          var img = cartImg(it);
          var meta = (it.variant_title && it.variant_title !== 'Default Title' ? esc(it.variant_title) : '') + (it.quantity > 1 ? ' · Qty ' + it.quantity : '');
          return '<div class="line" data-line="' + (i + 1) + '">' + (img ? '<img src="' + esc(img) + '" alt="">' : '<div></div>') +
            '<div><div class="n">' + esc(it.product_title) + '</div><div class="m">' + meta + '</div><button type="button" class="rm" data-remove="' + (i + 1) + '">Remove</button></div>' +
            '<div class="lp">' + money(it.final_line_price) + '</div></div>';
        }).join('');
      }
    }
    var sub = $('#cartSubtotal'); if (sub) sub.textContent = money(cart.total_price);
    var form = $('#cartCheckoutForm'); if (form) form.hidden = !cart.items.length;
  }
  function getCart() { return fetch(CG.routes.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function addItems(items) {
    return fetch(CG.routes.add + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body && (res.body.description || res.body.message) || 'Could not add to cart'); return false; }
        return getCart().then(function (c) { renderCart(c); openCart(); return true; });
      })
      .catch(function () { toast('Could not add to cart'); return false; });
  }
  function removeLine(line) {
    return fetch(CG.routes.change + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: 0 }) })
      .then(function (r) { return r.json(); }).then(renderCart).catch(function () { toast('Could not update cart'); });
  }

  /* ---------- product page ---------- */
  function fmtDate(d) {
    var m = d.toLocaleDateString('en-US', { month: 'short' }); var day = d.getDate();
    var s = day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th';
    return m + ' ' + day + s;
  }
  function plusDays(k) { var d = new Date(); d.setDate(d.getDate() + k); return d; }

  function buildRing(box, ring) {
    var unit = ring.getAttribute('data-text') || 'BEST VALUE • ', SPEED = 40, ADV = 7.4, lw = 0, lh = 0;
    function build() {
      var w = box.offsetWidth, h = box.offsetHeight, R = 20, inset = 9, r = R - inset;
      if (!w || !h) return; lw = w; lh = h;
      var d = 'M' + (inset + r) + ',' + inset + ' H' + (w - inset - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (w - inset) + ',' + (inset + r) + ' V' + (h - inset - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (w - inset - r) + ',' + (h - inset) + ' H' + (inset + r) + ' A' + r + ',' + r + ' 0 0 1 ' + inset + ',' + (h - inset - r) + ' V' + (inset + r) + ' A' + r + ',' + r + ' 0 0 1 ' + (inset + r) + ',' + inset + ' Z';
      var per = 2 * (w - 2 * inset - 2 * r) + 2 * (h - 2 * inset - 2 * r) + 2 * Math.PI * r;
      var k = Math.max(1, Math.round(per / (unit.length * ADV))), n = unit.length * k, str = '';
      for (var i = 0; i < k; i++) str += unit;
      var dur = (per / SPEED).toFixed(2);
      ring.innerHTML = '';
      for (var j = 0; j < n; j++) {
        var sp = document.createElement('span'); sp.className = 'ch'; sp.textContent = str[j];
        sp.style.setProperty('offset-path', "path('" + d + "')"); sp.style.setProperty('--d', dur + 's'); sp.style.setProperty('--dl', (-(j / n) * Number(dur)).toFixed(3) + 's');
        ring.appendChild(sp);
      }
    }
    build();
    if (window.ResizeObserver) new ResizeObserver(function () { if (Math.abs(box.offsetWidth - lw) > 1 || Math.abs(box.offsetHeight - lh) > 1) build(); }).observe(box);
  }

  function initProduct() {
    var page = $('[data-product-page]'); if (!page) return;
    var tiers = $$('[data-tier]', page);
    function selected() { return $('[data-tier].sel', page) || tiers[0]; }
    function total() {
      var t = selected(); if (!t) return 0;
      var sum = Number(t.getAttribute('data-price')) || 0;
      $$('.ax:checked', t).forEach(function (c) { sum += Number(c.getAttribute('data-price')) || 0; });
      return sum;
    }
    function refresh() {
      var t = selected(); var p = $('#stickyPrice'); if (p) p.textContent = money(total());
      var soldout = t && t.hasAttribute('data-soldout');
      $$('[data-atc]').forEach(function (b) { b.disabled = !!soldout; if (soldout) b.textContent = 'SOLD OUT'; else if (b.textContent === 'SOLD OUT') b.textContent = 'ADD TO CART'; });
    }
    function selectTier(el) { tiers.forEach(function (t) { t.classList.toggle('sel', t === el); }); refresh(); }
    tiers.forEach(function (t) { t.addEventListener('click', function () { if (!t.classList.contains('sel')) selectTier(t); }); });
    $$('.ax', page).forEach(function (c) { c.addEventListener('change', refresh); });
    refresh();

    var adding = false;
    function addToCart() {
      if (adding) return; var t = selected(); if (!t || t.hasAttribute('data-soldout')) return;
      var items = [{ id: Number(t.getAttribute('data-variant')), quantity: 1 }];
      $$('.ax:checked', t).forEach(function (c) { items.push({ id: Number(c.getAttribute('data-addon')), quantity: 1 }); });
      adding = true;
      var btns = $$('[data-atc]'); btns.forEach(function (b) { b.disabled = true; });
      addItems(items).then(function (ok) {
        adding = false; btns.forEach(function (b) { b.disabled = false; });
        if (ok) { var main = $('#atc'); if (main) { main.textContent = 'ADDED ✓'; setTimeout(function () { main.textContent = 'ADD TO CART'; }, 1150); } }
      });
    }
    $$('[data-atc]').forEach(function (b) { b.addEventListener('click', addToCart); });

    /* best value ring */
    var best = $('.tier.best', page); var ring = best && $('[data-ring]', best);
    if (best && ring) buildRing(best, ring);

    /* gallery */
    var track = $('#sliderTrack'), slides = track ? $$('.slide', track) : [], n = slides.length, cur = 0, slider = $('#slider');
    var dots = $('#slideDots');
    if (dots) dots.innerHTML = slides.map(function (_, i) { return '<button type="button" aria-label="Image ' + (i + 1) + '" data-goto="' + i + '"' + (i === 0 ? ' class="on"' : '') + '></button>'; }).join('');
    function go(i) {
      if (!n) return; cur = ((i % n) + n) % n;
      track.style.transform = 'translateX(-' + cur * 100 + '%)';
      var c = $('#slideCount'); if (c) c.textContent = (cur + 1) + ' / ' + n;
      $$('#slideDots button').forEach(function (b, k) { b.classList.toggle('on', k === cur); });
      $$('#slideThumbs button').forEach(function (b, k) { b.classList.toggle('sel', k === cur); });
    }
    $$('[data-slide]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); go(cur + Number(b.getAttribute('data-slide'))); }); });
    page.addEventListener('click', function (e) { var g = e.target.closest('[data-goto]'); if (g) go(Number(g.getAttribute('data-goto'))); });
    if (slider && track) {
      var drag = null;
      slider.addEventListener('pointerdown', function (e) { drag = { x: e.clientX, dx: 0 }; track.style.transition = 'none'; });
      slider.addEventListener('pointermove', function (e) { if (!drag) return; drag.dx = e.clientX - drag.x; track.style.transform = 'translateX(calc(-' + cur * 100 + '% + ' + drag.dx + 'px))'; });
      function end() { if (!drag) return; track.style.transition = ''; var dx = drag.dx; drag = null; if (Math.abs(dx) > 60) go(cur + (dx < 0 ? 1 : -1)); else go(cur); }
      slider.addEventListener('pointerup', end); slider.addEventListener('pointerleave', end); slider.addEventListener('pointercancel', end);
      $$('img', slider).forEach(function (im) { im.draggable = false; });
    }

    /* reviews carousel */
    var rt = $('#revTrack'), rs = rt ? $$('.rslide', rt) : [], ri = 0, rTimer;
    function goRev(i) { if (!rs.length) return; ri = ((i % rs.length) + rs.length) % rs.length; rt.style.transform = 'translateX(-' + ri * 100 + '%)'; $$('#revDots button').forEach(function (b, k) { b.classList.toggle('on', k === ri); }); }
    $$('[data-rev]').forEach(function (b) { b.addEventListener('click', function () { goRev(Number(b.getAttribute('data-rev'))); clearInterval(rTimer); }); });
    if (rs.length > 1 && !reduced) rTimer = setInterval(function () { goRev(ri + 1); }, 5500);

    /* timeline dates */
    $$('[data-date]').forEach(function (el) {
      var v = el.getAttribute('data-date').split('-').map(Number);
      el.textContent = v.length > 1 ? fmtDate(plusDays(v[0])) + ' - ' + fmtDate(plusDays(v[1])) : fmtDate(plusDays(v[0]));
    });

    /* sticky bar */
    var atc = $('#atc'), sticky = $('#stickyBar');
    if (atc && sticky && window.IntersectionObserver) {
      new IntersectionObserver(function (en) { var b = en[0]; sticky.classList.toggle('up', !b.isIntersecting && b.boundingClientRect.top < 0); }, { threshold: 0 }).observe(atc);
    }
  }

  /* ---------- global delegated events ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-open-cart]'))) { e.preventDefault(); openCart(); return; }
    if ((el = t.closest('[data-close-cart]'))) { if (el.tagName !== 'A') e.preventDefault(); closeCart(); return; }
    if ((el = t.closest('[data-open-menu]'))) { e.preventDefault(); openMenu(); return; }
    if ((el = t.closest('[data-close-menu]'))) { if (el.tagName !== 'A') e.preventDefault(); closeMenu(); return; }
    if ((el = t.closest('[data-toggle-search]'))) { e.preventDefault(); var sb = $('#searchbar'); if (sb) { sb.classList.toggle('open'); if (sb.classList.contains('open')) { var inp = $('input', sb); if (inp) inp.focus(); } } return; }
    if ((el = t.closest('[data-add]'))) { e.preventDefault(); e.stopPropagation(); if (el.disabled) return; el.disabled = true; addItems([{ id: Number(el.getAttribute('data-add')), quantity: 1 }]).then(function () { el.disabled = false; }); return; }
    if ((el = t.closest('[data-remove]'))) { e.preventDefault(); removeLine(Number(el.getAttribute('data-remove'))); return; }
    if ((el = t.closest('[data-hscroll]'))) { e.preventDefault(); var car = document.getElementById(el.getAttribute('data-hscroll')); if (car) car.scrollBy({ left: (el.getAttribute('data-dir') === '-1' ? -1 : 1) * Math.round(car.clientWidth * 0.82), behavior: 'smooth' }); return; }
    if ((el = t.closest('.faq .q > button'))) {
      var q = el.parentNode, open = q.classList.toggle('open'), a = $('.a', q);
      el.setAttribute('aria-expanded', open ? 'true' : 'false'); if (a) a.style.maxHeight = open ? '650px' : '0px'; return;
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); } });
  var trackForm = $('[data-track-form]');
  if (trackForm) trackForm.addEventListener('submit', function (e) { e.preventDefault(); var num = (new FormData(trackForm).get('tracking') || '').toString().trim(); if (num) window.open('https://t.17track.net/en#nums=' + encodeURIComponent(num), '_blank', 'noopener'); });

  initProduct();
})();
